import { render } from "./Projektek.vue?vue&type=template&id=78ba2f4f&scoped=true"
import script from "./Projektek.vue?vue&type=script&lang=js"
export * from "./Projektek.vue?vue&type=script&lang=js"

import "./Projektek.vue?vue&type=style&index=0&id=78ba2f4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ba2f4f"]])

export default __exports__